module.exports = __webpack_public_path__ + "img/pasted image 0.a2c552cc.png";